import { render, staticRenderFns } from "./insureDetail.vue?vue&type=template&id=7c82026e&scoped=true"
import script from "./insureDetail.vue?vue&type=script&lang=js"
export * from "./insureDetail.vue?vue&type=script&lang=js"
import style0 from "./insureDetail.vue?vue&type=style&index=0&id=7c82026e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82026e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c82026e')) {
      api.createRecord('7c82026e', component.options)
    } else {
      api.reload('7c82026e', component.options)
    }
    module.hot.accept("./insureDetail.vue?vue&type=template&id=7c82026e&scoped=true", function () {
      api.rerender('7c82026e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/components/insureDetail.vue"
export default component.exports